import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeetingView from "./MeetingView";
import {userDataByUserId, saveTheMeetingRating} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    userMeetingDetailsByUserId: state.baMeetingReducer.userMeetingDetailsByUserId,
    saveMeetingRatingByImmediateSenior: state.baMeetingReducer.saveMeetingRatingByImmediateSenior
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            userDataByUserId,
            saveTheMeetingRating
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MeetingView);
